import { defineMessages } from "react-intl";

import { AwardType } from "~/types/api-types";

export const listingAwardsBadgeCategories: Record<
  AwardType,
  { id: string; defaultMessage: string }
> = defineMessages({
  ["podcast"]: {
    id: "listing.awards_badge.category_podcast",
    defaultMessage: "Podcasts",
  },
  ["architectural"]: {
    id: "listing.awards_badge.category_architectural",
    defaultMessage: "Architectural Spaces",
  },
  ["outdoor_event"]: {
    id: "listing.awards_badge.category_outdoor_event",
    defaultMessage: "Outdoor Events",
  },
  ["birthday_party"]: {
    id: "listing.awards_badge.category_birthday_party",
    defaultMessage: "Birthday Parties",
  },
  ["diy_wedding"]: {
    id: "listing.awards_badge.category_diy_wedding",
    defaultMessage: "DIY Weddings",
  },
  ["photoshoot"]: {
    id: "listing.awards_badge.category_photoshoot",
    defaultMessage: "Photoshoots",
  },
  ["team_offsite"]: {
    id: "listing.awards_badge.category_team_offsite",
    defaultMessage: "Team Offsites",
  },
  ["global"]: {
    id: "listing.awards_badge.category_global",
    defaultMessage: "Global Spaces",
  },
  ["dinner_party"]: {
    id: "listing.awards_badge.category_dinner_party",
    defaultMessage: "Dinner Parties",
  },
  ["baby_shower"]: {
    id: "listing.awards_badge.category_baby_shower",
    defaultMessage: "Baby Showers",
  },
});
